/* eslint-disable max-len */
export const IMPACT_FIELD_HINTS = {
  lciaMethod:
    'The characterization method used to convert LCI results to environmental impact scores.',
  gwpHorizon:
    'The time horizon for global warming potential characterization.',
  biogenicHandling:
    'How biogenic CO2 (carbon from biological sources, e.g., wood, agricultural residues) is treated in the calculation.',
  luc:
    'Whether to include greenhouse gas emissions arising from land use change (relevant for bio-based inputs, deforestation-linked agricultural commodities).',
  sequestration:
    'Whether to account for temporary carbon storage in the product during its use phase.',
  efDatabaseVersion:
    'The version of the background emission factor database used for this calculation. Locked to the current platform version at time of calculation.',
  uncertainty:
    'Whether to run a Monte Carlo uncertainty analysis alongside the primary calculation.',
  uncertaintyIterations:
    'Number of Monte Carlo iterations to run. Higher values improve precision but increase calculation time.',
  calculatePcf: 'The button that initiates the PCF calculation engine.'
} as const;
